# F63 — Asset Class list screen
# Route: /asset/classes

page-config-asset-class-list:
  type: Page
  archetype: list
  meta:
    title: $t.config_asset_class.meta_title
    route: /asset/classes
    layout: shell
    auth: required
  data:
    classes:
      model: AssetClass[]
      refresh: on_mount
  spatial:
    display: flex
    direction: column
    gap: $spacing.lg
    padding: $spacing.lg
    padding_inline: $spacing.xl
    overflow: auto
  tokens:
    background: $color_scheme.light.color.surface
  children:
    - config-ac-list-sm-notice
    - config-ac-list-content

config-ac-list-sm-notice:
  type: SmNotice
  content: $t.common.sm_notice_desktop

config-ac-list-content:
  type: Section
  spatial:
    display: flex
    direction: column
    gap: $spacing.lg
    responsive:
      sm:
        display: none
  children:
    - config-ac-list-header
    - config-ac-list-table

config-ac-list-header:
  type: PageHeader
  content: $t.config_asset_class.list_title
  actions:
    - label: $t.config_asset_class.btn_create
      route: /asset/classes/new
      color: info

config-ac-list-table:
  type: Table
  bind:
    rows: classes
  empty: config-ac-list-empty
  # M1 list-filter adoption (DEC-090) — opt-in client-side quick-filter: this
  # list had no filter at all. Case-insensitive substring across the visible
  # columns + native clear, over the loaded rows.
  filter:
    fields: [displayName, version, status]
    placeholder: $t.common.quick_filter
  columns:
    - key: displayName
      label: $t.config_asset_class.col_name
      tokens:
        font_size: $font.size.sm
    - key: version
      label: $t.config_asset_class.col_version
      tokens:
        font_size: $font.size.sm
    - key: status
      label: $t.config_asset_class.col_status
      tokens:
        font_size: $font.size.sm
  row_action:
    type: navigate
    route: /asset/classes/:id
    params:
      id: $row.id
  a11y:
    label: $t.config_asset_class.table_label
  tokens:
    border: $border.default
    radius: $radius.md
    background: $color_scheme.light.color.surface-elevated

config-ac-list-empty:
  type: EmptyState
  content: $t.config_asset_class.empty_state
  tokens:
    color: $color_scheme.light.color.on-surface-muted
    font_size: $font.size.md
  spatial:
    padding: $spacing.lg
